export const HEADER_CTA_CLICKED = 'Header CTA Clicked';
